<template>
  <div>
    <div class="bg-scroll bg-center bg-cover books">
      <h1 class="is-size-1 has-text-white font-second--bold">Register</h1>
    </div>
    <div class="pay-wrapper columns is-fullwidth is-fullheight">
      <div class="column">
        <div class="card w-6/12 mx-auto">
          <header class="card-header">
            <p class="card-header-title">
              Sign up and Pay
            </p>
          </header>
          <div class="card-content font-main">
            For a full listing of the courses 
            offered, visit the
            <a
              class="learning-link font-main--bold"
              @click.stop="$router.push('/learning').catch(e => e)"
            >
              Learning</a
            >
            page.
            <p>
                To specify the courses you would like to take, please email Dr. Fuller 
                at rtffuller@gmail.com.
                Be sure to include
                <span class="font-main--bi"> your name</span> and the
                <span class="font-main--bi"
                  >name of the class(es) for which you would like to
                  register.</span>
                  Payment is now handled outside of this site. Instructions can be found by
                  downloading the pdf file below. Contact Dr. Fuller with any questions.
              </p>
          </div>
          <footer class="card-footer">
            <a
              href="http://syllabus.russelltfuller.com/Payments.pdf"
              target="_blank"
              class="card-footer-item button"
            >
            Download Payment Instructions
            </a>
          </footer>
        </div>
      </div>
    </div>
    <div class="budget">
      <h1>Do not let the cost keep you from taking classes. We can try to fit your budget. Contact me.</h1>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Register',
}
</script>
<style lang="scss">
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';
.budget {
  background-color: beige;
  padding: 3rem 25vw;
  font-size: larger;
}
.primary-background {
  background-color: $primary;
}
.text-dark {
  color: black;
}
.books {
  background-image: $mask-dark, url('../assets/Tehillim.jpg');
  position: relative;
  overflow-y: visible;
  height: 20em;
  & > h1 {
    position: absolute;
    top: 50%;
    left: 10%;
  }
}
.pay-wrapper {
  padding: 5em;
}
.learning-link {
  color: $primary;
  &:hover {
    font-style: normal;
  }
}
.card-content {
  min-height: 12em;
}
</style>
